import { TypeAppliedTheme } from "@src/Stores/Themes/types";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Grid, Typography } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";

const useStyles = makeStyles(() => ({
  paperRoot: {
    marginTop: "2em",
    opacity: "0.9",
    minWidth: "320px",
  },
  loginGrid: {
    minHeight: "100vh",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  loginLogo: {
    maxWidth: "15rem",
    maxHeight: "3rem",
  },
}));

export default useStyles;

export const STGrid = styled(Grid)`
    background-image: url(${(props: { loginbackgroundlandscapeimageurl: string }) =>
        props.loginbackgroundlandscapeimageurl});
    background-color: ${(props: { theme: TypeAppliedTheme }) => (props.theme ? props.theme.secondaryColor : "")};
    ${theme.breakpoints.down("sm")} {
    background-image: url(${(props: { loginbackgroundportraitimageurl: string }) =>
        props.loginbackgroundportraitimageurl});
    }

    @media (max-width: 1000px) {
        background: url(${(props: { loginbackgroundlandscapeimageurl: string }) =>
        props.loginbackgroundlandscapeimageurl}), ${(props: { theme: TypeAppliedTheme }) => (props.theme ? props.theme.secondaryColor : "")};
        ${theme.breakpoints.down("sm")} {
        background: url(${(props: { loginbackgroundportraitimageurl: string }) =>
        props.loginbackgroundportraitimageurl}),${(props: { theme: TypeAppliedTheme }) => (props.theme ? props.theme.secondaryColor : "")};
        }
    }
`;

export const ForgotPasswordLink = styled.a`
  && {
    text-decoration: none;
    cursor: pointer;
    font-weight: 400;
    font-style: normal;
    font-size: 1em;
    padding-top: 16px;
  }
`;

export const OrganizationGrid = styled(Grid)`
  && {
    margin-top: 16px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const OrganizationText = styled.a`
  && {
    margin-right: 8px;
    font-weight: 550;
    color: rgba(0, 0, 0, 0.87) !important;
    text-decoration: none !important;
  }
`;
